// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3f26i","list":"styles_list__jfS8A"};